import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FormControlLabel, Grid, Switch, TextField } from "@mui/material";
import { AutocompleteComponent } from "../../components/Autocomplete/AutocompleteComponent";
import { getLogo } from "../../redux/actions/brands/brandsAction_V2";

export const ModalRegenerateFiles = ({
  idStation,
  logo,
  comment,
  hasBankReferences,
  setLogo,
  setComment,
  setHasBankReferences,
}) => {
  const { logos } = useSelector(({ brandsReducer }) => brandsReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    if (logos?.length === 0 || idStation !== logos[0]?.idStation) {
      dispatch(getLogo(idStation, false));
    }
  }, [logos]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <AutocompleteComponent
          label="Seleccione logo"
          options={logos}
          name="logo"
          value={logo}
          customAction={setLogo}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          label="Comentarios"
          name="comment"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          fullWidth
          multiline
          rows={3}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Switch
              checked={hasBankReferences}
              onChange={(e) => setHasBankReferences(e.target.checked)}
              color="primary"
            />
          }
          label="¿Agregar referencias bancarias?"
        />
      </Grid>
    </Grid>
  );
};
